export default __webpack_public_path__ + "static/dev-c4512370f4cae84622d5f180266ab850.png";